import $ from 'jquery';

const POSTBACK_CLASS = 'is-post-back';

$(document).ready(() => {
  if (!window.Sys) {
    return;
  }

  // Do postback class stuff so we can only run the anmiaton when clicked and not on postback too
  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(() => {
    bindPostbackClass();
  });

  // Bind clicking of text to also check the box
  bindTextClicking();
});

function bindPostbackClass() {
  $('.js-checkbox').addClass(POSTBACK_CLASS);
  $('.js-checkbox').click((e) => {
    $(e.currentTarget).removeClass(POSTBACK_CLASS);
  });
}

function bindTextClicking() {
  $('.js-checkbox-text').click((e) => {
    const checkbox = $($(e.currentTarget).siblings('.js-checkbox')[0]);
    checkbox.trigger('click');
  });
}
